import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors, opacities } from '../../../defaultTheme';
import Small from '../../typography/Small';
export const Container = styled.label `
  display: flex;
  align-items: start;
  justify-content: left;
  width: 100%;
  cursor: pointer;
`;
export const CheckboxContainer = styled.div `
  display: inline-block;
  vertical-align: middle;
  position: relative;
  ${({ isLabelOnLeft }) => isLabelOnLeft ? 'margin-left: 12px;' : 'margin-right: 12px;'}
  padding: ${(props) => (props.padding ? props.padding : '0px')}
`;
export const CheckboxIcon = styled(FontAwesomeIcon) `
  display: inline-block;
`;
/*
 * Hide checkbox visually but remain accessible to screen readers.
 * Source: https://polished.js.org/docs/#hidevisually
 */
export const HiddenCheckbox = styled.input `
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;

  &:hover {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    left: -9px;
    top: -9px;
    z-index: -9;
    clip: auto;
    -webkit-appearance: none;
    outline: none;
    transition: opacity 0.3s ease 0.1s, transform 0.2s ease 0.1s;
    opacity: ${opacities.dark70};
    background-color: ${colors.lightGrey};

    &:checked {
      z-index: -10;
    }

    &::-ms-check {
      display: none;
    }

    &:not(:checked) {
      z-index: 0;
      opacity: ${opacities.light38};
    }
  }
`;
export const StyledCheckbox = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  border: 2px solid
    ${({ hasError }) => (hasError ? colors.error : colors.mediumGrey)};
  border-radius: 2px;
  transition: all 150ms;

  ${CheckboxIcon} {
    visibility: ${({ isChecked }) => (isChecked ? 'visible' : 'hidden')};
  }

  ${HiddenCheckbox}:checked + && {
    background: ${({ theme }) => theme.checkbox.background};
    border: 2px solid
      ${({ hasError, theme }) => hasError ? colors.error : theme.checkbox.background};
  }

  ${HiddenCheckbox}:disabled + & {
    ${({ isChecked }) => isChecked && 'background-color: #000'};
    opacity: ${opacities.light38};
  }

  ${HiddenCheckbox}:focus + & {
    outline: ${({ theme }) => theme.focus} auto 5px;
  }

  ${HiddenCheckbox}:focus :not(:disabled) + & {
    &::before {
      content: '';
      position: absolute;
      display: block;
      z-index: -1;
      width: 16px;
      height: 16px;
      opacity: 0.25;
      border-radius: 50%;
      background-color: ${colors.heavyGrey};
    }
  }
`;
export const ErrorIconWrapper = styled.div `
  height: 100%;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ErrorText = styled(Small) `
  display: block;
  padding: 5px 0px;
  color: ${colors.error};
`;
export const ErrorWrapper = styled.div `
  display: flex;
  color: ${colors.error};
  align-items: center;
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
